import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../api';
import type { SavedSearch } from '../types';
import { loadLastResults } from '../lastResults';
import { Icon } from '../components/Icon';

export function SearchesPage() {
  const [list, setList] = useState<SavedSearch[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const nav = useNavigate();

  const last = loadLastResults();
  const load = () => api.listSearches().then((r) => setList(r.searches)).catch((e) => setError(e.message));
  useEffect(() => { load(); }, []);

  const del = async (s: SavedSearch) => {
    if (!confirm(`Delete "${s.name}"?`)) return;
    await api.deleteSearch(s.id);
    load();
  };

  return (
    <div className="stack">
      {last && (
        <Link to={last.path} className="card row between" style={{ color: 'inherit' }}>
          <div><strong>Back to results</strong><div className="muted small">{last.name} · {last.results.length} match{last.results.length === 1 ? '' : 'es'}</div></div>
          <span className="muted">›</span>
        </Link>
      )}
      <Link to="/searches/new" className="btn block secondary" style={{ textAlign: 'center', color: 'inherit' }}><Icon name="plus" size={18} /> New search</Link>
      {error && <div className="error">{error}</div>}
      {list === null ? <div className="spinner">Loading…</div> : list.length === 0 ? (
        <div className="empty">No saved searches yet. Create one to find musicians near you with similar taste.</div>
      ) : (
        <>
          <h2 className="section">Saved searches</h2>
          {list.map((s) => (
            <div className="card saved-search" key={s.id}>
              <div className="row between">
                <strong className="saved-name">{s.name}</strong>
                <div className="row" style={{ gap: 4 }}>
                  <button className="btn ghost sm" onClick={() => nav(`/searches/${s.id}/edit`)}>Edit</button>
                  <button className="icon-btn" onClick={() => del(s)} aria-label="Delete">✕</button>
                </div>
              </div>
              <button className="btn block run" onClick={() => nav(`/searches/${s.id}/results`)}><Icon name="play" size={22} /> Run</button>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
